export enum IncidentTypeUi {
    AbandonedVehicle,
    DocumentIncomplete,
    FinancialResponsibility,
    MandatoryInsurance,
    OpsOfLawLienVehicle,
    OpsOfLawLienCustomer,
    Tteap,
    FraudVehicle,
    FraudCustomer,
    AbandonedVehicleFee,
    NsfPenaltyDue,
    NSFCancellation,
    NonpaymentOfJudgment,
    DefaultJudgment,
    FailureToComplyWithCIID,
    FinancialResponsibilityCourtOrdered4135B,
    FinancialResponsibilityCourtOrdered4135C,
    FailedVisionExam,
    CommonIncident,
    UnderageIncident,
    LawEnforcementIncident,
    FinanceCollection
}
